import { PRIVATE_HTTP } from "./index";

const INSURANCE_SEARCH = "api/insurancesale/search";

export var insuranceSearch = (request) => {
   const promise = PRIVATE_HTTP().post(INSURANCE_SEARCH, request);
   return promise.then((response) => {
      return response.data;
   });
};
